// Main JS (in UMD format)
import VueTimepicker from 'vue2-timepicker'
import Vue from 'vue'

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
Vue.component('VueTimepicker', VueTimepicker)